import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'A user opens the Translate wizard to translate the text in an image',
  name: 'translation_invoked',
  params: [
    {
      description: 'The surface the Translate wizard opened on. Only the canvas hosts it today',
      name: 'surface',
      required: true,
      type: 'enum',
      values: ['canvas'],
    },
  ],
};

export default META;
